import { useCallback } from 'react';
import { findLinkRange } from '../helpers';
import { EditorState, Modifier, RichUtils, SelectionState } from 'draft-js';

export const useApplyLink = () =>
  useCallback(
    (data, editMode) => (editMode ? editLink(data) : addLink(data)),
    []
  );

function addLink({ state, text, url }) {
  return insertTextWithLink({
    state,
    selection: state.getSelection(),
    text,
    url,
    removeOldEntity: false,
  });
}

function editLink({ state, text, url }) {
  const selection = state.getSelection();
  const currentContent = state.getCurrentContent();
  const blockForKey = currentContent.getBlockForKey(selection.getStartKey());

  const linkRange = findLinkRange(blockForKey, currentContent, selection);

  if (linkRange) {
    return insertTextWithLink({
      state,
      selection: linkRange,
      text,
      url,
      removeOldEntity: true,
    });
  }

  return state;
}

function insertTextWithLink({
  state,
  selection,
  text,
  url,
  removeOldEntity = false,
}) {
  let nextState = insertText({ state, selection, text, removeOldEntity });

  const linkContent = nextState
    .getCurrentContent()
    .createEntity('LINK', 'MUTABLE', { url });
  const linkKey = linkContent.getLastCreatedEntityKey();
  nextState = EditorState.set(nextState, { currentContent: linkContent });

  const linkSelection = nextState.getSelection().merge({
    anchorOffset: selection.getStartOffset(),
    focusOffset: selection.getStartOffset() + text.length,
  });
  const afterLinkSelection = new SelectionState({
    anchorKey: linkSelection.getAnchorKey(),
    anchorOffset: linkSelection.getEndOffset(),
    focusKey: linkSelection.getFocusKey(),
    focusOffset: linkSelection.getEndOffset(),
    hasFocus: true,
  });
  nextState = RichUtils.toggleLink(nextState, linkSelection, linkKey);

  const extraSpaceContent = Modifier.insertText(
    nextState.getCurrentContent(),
    afterLinkSelection,
    '\u200B'
  );
  nextState = EditorState.push(
    nextState,
    extraSpaceContent,
    'insert-characters'
  );

  return EditorState.acceptSelection(nextState, afterLinkSelection);
}

function insertText({ state, selection, text, removeOldEntity = false }) {
  const content = removeOldEntity
    ? Modifier.applyEntity(state.getCurrentContent(), selection, null)
    : state.getCurrentContent();

  const nextContent = Modifier.replaceText(content, selection, text);
  return EditorState.push(state, nextContent, 'insert-characters');
}
